export default __webpack_public_path__ + "static/media/Spin torre RI_Interactive LightMix0016.4b25f9d2.webp";